(() => {
  const key = '__otheriverStudio';
  if (window[key]) { window[key].refresh(); return; }
  let context;
  let timer;
  let observer;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function destroy() {
    window.clearTimeout(timer);
    observer?.disconnect();
    observer = undefined;
    context?.revert();
    context = undefined;
    document.querySelectorAll('.or-story__visual').forEach(el => el.classList.remove('is-enhanced'));
    document.querySelectorAll('.or-story').forEach(el => el.classList.remove('is-motion-ready'));
  }
  function init(attempt = 0) {
    const roots = document.querySelectorAll('[data-or-studio]');
    if (!roots.length || motion.matches) return;
    if (!window.gsap || !window.ScrollTrigger) {
      if (attempt < 80) timer = window.setTimeout(() => init(attempt + 1), 75);
      return;
    }
    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);
    context = gsap.context(() => {
      roots.forEach(root => {
        root.querySelectorAll('.or-reveal').forEach(el => {
          gsap.from(el, { y: 28, opacity: 0, duration: .65, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 94%', once: true } });
        });
        const mm = gsap.matchMedia();
        mm.add('(min-width: 768px)', () => {
          const story = root.querySelector('.or-story');
          const visual = story?.querySelector('.or-story__visual');
          if (!visual) return;
          const steps = Array.from(story.querySelectorAll('[data-or-step]'));
          const scenes = Array.from(visual.querySelectorAll('[data-or-scene]'));
          const show = index => {
            steps.forEach((el, i) => el.classList.toggle('is-active', i === index));
            scenes.forEach((el, i) => el.classList.toggle('is-active', i === index));
          };
          visual.classList.add('is-enhanced');
          story.classList.add('is-motion-ready');
          show(0);
          const selectVisibleStep = () => {
            let index = 0;
            steps.forEach((el, i) => { if (el.getBoundingClientRect().top <= window.innerHeight * .5) index = i; });
            show(index);
          };
          ScrollTrigger.create({ trigger: story, start: 'top bottom', end: 'bottom top', onUpdate: selectVisibleStep, onRefresh: selectVisibleStep });
          selectVisibleStep();
          return () => { visual.classList.remove('is-enhanced'); story.classList.remove('is-motion-ready'); steps.forEach(el => el.classList.remove('is-active')); };
        });
      });
    });
    document.querySelectorAll('[data-or-studio] img').forEach(img => {
      if (!img.complete) img.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    });
    ScrollTrigger.refresh();
  }
  const refresh = () => { destroy(); init(); };
  window[key] = { refresh, destroy };
  motion.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
